export const LIFE_MILESTONE_1_CONSTANTS = {
  METADATA_TITLES: {
    metadata: "Milestones",
  },

  DEFAULT_ROW: {
    id: "1",
    meta_milestone_label: "",
    meta_heading: "",
    meta_description: "",
    meta_priority: 1,
    meta_status: 1,
  },

  METADATA_FIELDS: [
    {
      fieldName: "meta_milestone_label",
      label: "Step label (e.g. GROW)",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "GROW",
      required: true,
      defaultValue: "",
    },
    {
      fieldName: "meta_heading",
      label: "Heading",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "From Potential to Power",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "meta_description",
      label: "Description",
      value: "",
      valueType: "string",
      filedType: "TEXTAREA",
      placeholder: "Supporting copy for this step",
      required: false,
      defaultValue: "",
      rows: 4,
    },
    {
      fieldName: "meta_priority",
      label: "Order",
      value: 1,
      valueType: "number",
      filedType: "INPUT",
      placeholder: "1",
      required: false,
      defaultValue: 1,
    },
    {
      fieldName: "meta_status",
      label: "Active",
      value: 1,
      valueType: "number",
      filedType: "TOGGLE",
      placeholder: "",
      required: false,
      defaultValue: 1,
    },
  ],

  LIFE_MILESTONE_FIELDS_CONFIG: [
    {
      fieldName: "title_prefix",
      label: "Title — prefix",
      value: "Life after ",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Life after ",
      required: false,
      defaultValue: "Life after ",
    },
    {
      fieldName: "title_highlight",
      label: "Title — highlighted phrase",
      value: "IIT Kharagpur",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "IIT Kharagpur",
      required: false,
      defaultValue: "IIT Kharagpur",
    },
    {
      fieldName: "title_suffix",
      label: "Title — suffix (optional)",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Optional text after highlight",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "title_highlight_color",
      label: "Highlighted phrase color",
      value: "#FFC600",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#FFC600",
      required: false,
      defaultValue: "#FFC600",
    },
    {
      fieldName: "background_color",
      label: "Section background",
      value: "#291973",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#291973",
      required: false,
      defaultValue: "#291973",
    },
    {
      fieldName: "image_frame_color",
      label: "Image frame / accent behind photo",
      value: "#E1473F",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#E1473F",
      required: false,
      defaultValue: "#E1473F",
    },
    {
      fieldName: "hero_image",
      label: "Hero image (shared by all milestones)",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload hero image",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "hero_image_alt",
      label: "Hero image alt text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Describe the hero image",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "timeline_color",
      label: "Vertical timeline line color",
      value: "#807070",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#807070",
      required: false,
      defaultValue: "#807070",
    },
    {
      fieldName: "auto_rotate_seconds",
      label: "Auto-advance steps (seconds, 0 = off)",
      value: 0,
      valueType: "number",
      filedType: "INPUT",
      placeholder: "0",
      required: false,
      defaultValue: 0,
    },
    {
      fieldName: "status",
      label: "Section Status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable Section",
      defaultValue: true,
    },
  ],
};
